export enum NoteType {
  System = 1,
  UserCreated = 2,
}
